import apiClient from "../utils/apiClient";

export const getAutos = async () => {
  try {
    const response = await apiClient.get("/renta-autos");
    return response?.data;
  } catch (error) {
    throw new Error("Error connection data: ", error);
  }
};
